import PropTypes from 'prop-types'
import Skeleton from 'react-loading-skeleton'
import ReactMarkdown from 'react-markdown'
import { Heading } from '../../../../components/ui/Heading'
import ScoreIndicator from './ScoreIndicator'

export default function ProfessionalInterestsInsights({
  group_match,
  category_fit,
  evaluation_level,
  title,
  isLoading,
  onClick
}) {
  return (
    <div className='rounded-lg border border-lightGrey bg-lightPaleGrey'>
      <div className='flex px-10 py-4'>
        <div
          onClick={onClick}
          className='flex transform-gpu cursor-pointer items-center transition-transform duration-200 ease-out hover:scale-105 focus-visible:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 motion-reduce:transition-none motion-reduce:hover:scale-100'
          role='button'
        >
          {isLoading ? (
            <Skeleton height={40} width={40} />
          ) : (
            <ScoreIndicator group_match={group_match} />
          )}
          <Heading className={'ml-6 text-buttonSecondaryBlue'} level={4}>
            {isLoading ? <Skeleton width={100} /> : title}
          </Heading>
        </div>
      </div>
      <div className='border-t border-lightGrey p-6'>
        {isLoading ? (
          <Skeleton count={3} />
        ) : (
          <ReactMarkdown className='text-base font-normal text-darkBlack'>
            {`${category_fit} ${evaluation_level}`}
          </ReactMarkdown>
        )}
      </div>
    </div>
  )
}

ProfessionalInterestsInsights.propTypes = {
  group_match: PropTypes.number.isRequired,
  category_fit: PropTypes.string.isRequired,
  evaluation_level: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}
